import './App.css';
import Footer from './components/Footer';
import Profile from './components/Profile';

function App() {
  return (
    <div className="App">
      <header className="App-header">
      <Profile/>
      </header>
      
      <Footer/>
    </div>
  );
}

export default App;
